import React, { useEffect, useState } from "react";
import axios from "axios";

export default function SellerProfile() {
  const [seller, setSeller] = useState({ name: "", email: "", phone: "" });
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("sellerToken");

  // ✅ Fetch seller details
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get("https://haaterkaj-backend-1.onrender.com/api/seller/me", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data.success) {
          setSeller(res.data.seller);
        }
      } catch (err) {
        console.error("Error fetching seller profile:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [token]);

  // ✅ Handle update
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.put(
        "https://haaterkaj-backend-1.onrender.com/api/seller/update-profile",
        { name: seller.name, phone: seller.phone },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(res.data.message);
    } catch (err) {
      console.error("Error updating profile:", err);
      alert("Failed to update profile");
    }
  };

  if (loading) return <div className="p-6 text-center">Loading...</div>;

  return (
    <div className="max-w-md mx-auto mt-10 bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-4 text-amber-700 text-center">
        Seller Profile
      </h2>
      <form onSubmit={handleUpdate}>
        <label className="block mb-2 font-semibold">Name</label>
        <input
          type="text"
          value={seller.name}
          onChange={(e) => setSeller({ ...seller, name: e.target.value })}
          className="border p-2 w-full mb-3 rounded"
          placeholder="Your Name"
        />

        <label className="block mb-2 font-semibold">Email</label>
        <input
          type="email"
          value={seller.email}
          disabled
          className="border p-2 w-full mb-3 rounded bg-gray-100"
        />

        <label className="block mb-2 font-semibold">Phone</label>
        <input
          type="text"
          value={seller.phone}
          onChange={(e) => setSeller({ ...seller, phone: e.target.value })}
          className="border p-2 w-full mb-3 rounded"
          placeholder="Phone Number"
        />

        <button
          type="submit"
          className="bg-amber-600 text-white px-4 py-2 rounded w-full hover:bg-amber-700"
        >
          Update Profile
        </button>
      </form>
    </div>
  );
}
